var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9999,
    y: 23,
    width: 8,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.9999,
    y: 23,
    width: 2,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9999,
    y: 18,
    width: 8,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.9999,
    y: 18,
    width: 2,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9999,
    y: 13,
    width: 8,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9.9999,
    y: 13,
    width: 2,
    height: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z",
    transform: "translate(0 0)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.d4812358ce0a105bc1a3f527a6853221.svg";
export { ForwardRef as ReactComponent };